import React from 'react';
import Typography from '@mui/material/Typography';

import type { EMessageChannel } from 'src/services/api';
import { ChannelIcon, getChannelLabel } from 'src/components/channel-icon';

import styles from 'src/pages/landlord/leads/messages/components/messages-container/ChannelSwitchDivider.module.css';

type Props = {
    channel: EMessageChannel;
}

/**
 * Marks the point where a conversation moved to another channel, so it is obvious
 * that e.g. a Facebook Messenger thread continued over text once we had a phone number.
 */
export default function ChannelSwitchDivider({ channel }: Props) {
    return (
        <div className={styles.divider} data-testid={`channel-switch-${channel}`}>
            <span className={styles.line} aria-hidden="true" />
            <span className={styles.pill}>
                <ChannelIcon channel={channel} size={13} className={styles.icon} />
                <Typography variant="caption" component="span" color="inherit">
                    Switched to {getChannelLabel(channel)}
                </Typography>
            </span>
            <span className={styles.line} aria-hidden="true" />
        </div>
    );
}
